import Loadable from 'react-loadable';

import { LoadingPage } from 'components/LoadingPage';

export const PaymentDetailLoadable = Loadable({
  loader: () => import('./index'),
  loading: LoadingPage,
});
